module.exports = __webpack_public_path__ + "img/banner_recommend_2.3ff1390c.png";